import axios from 'axios';
import { axiosInstance, getAuthToken } from "../fgs/context/RequestContext";

const BASE_URL = 'https://api.fgsgeotecnia.com';
export const RESOURCES_BASE_URL = "https://resources.fgsgeotecnia.com";

export const getInitialData = async () => {
  return axiosInstance.get(`${BASE_URL}/initial_data`);
};

export const doSignin = async (form) => {
  return axios.post(`${BASE_URL}/authenticate`, form, { headers: { Authorization: getAuthToken() } });
};

export const createUserResource = async (userId, payload) => {
  return axiosInstance.post(`${BASE_URL}/users/${userId}/user_resources`, { resource: payload });
};

export const updateUserResource = async (userId, resourceId, payload) => {
  return axiosInstance.put(`${BASE_URL}/users/${userId}/user_resources/${resourceId}`, { resource: payload });
};

export const getUserResource = async (userId, resourceId) => {
  return axiosInstance.get(`${BASE_URL}/users/${userId}/user_resources/${resourceId}`);
};

export const getUserResources = async (id) => {
  return axiosInstance.get(`${BASE_URL}/users/${id}/user_resources${window.location.search}`);
};

export const deleteResources = async (userId, ids) => {
  if (ids && ids.length === 1) {
    return axiosInstance.delete(`${BASE_URL}/users/${userId}/user_resources/${ids[0]}`);
  }

  return axiosInstance.post(`${BASE_URL}/users/${userId}/user_resources/destroy_all`, { ids });
};

export const updateDirectory = async (id, payload) => {
  return axiosInstance.put(`${BASE_URL}/directories/${id}`, { ...payload });
};

export const getDirectories = async () => {
  return axiosInstance.get(`${BASE_URL}/directories${window.location.search}`);
};

export const getDirectory = async (id) => {
  return axiosInstance.get(`${BASE_URL}/directories/${id}`);
};

export const createDirectory = async (payload) => {
  return axiosInstance.post(`${BASE_URL}/directories`, payload);
};

export const getUserFolders = async (id, inputValue) => {
  const url = inputValue
    ? `${BASE_URL}/directories/names?dirName=${inputValue}&userId=${id}`
    : `${BASE_URL}/directories/names?userId=${id}`;
  return axiosInstance.get(url);
};

export const getUserNames = async (inputValue) => {
  const url = inputValue ? `${BASE_URL}/users/names?name=${inputValue}` : `${BASE_URL}/users/names`;
  return axiosInstance.get(url);
};

export const createDownloadRequest = (userId) => {
  return axiosInstance.post(`${BASE_URL}/documents/download_request`, { userId });
};

export const downloadDocuments = (ids, requestId) => {
  window.open(`${BASE_URL}/documents/download?ids=${ids}&requestId=${requestId}`, "_blank");
};

export const createDocumentRequest = async (payload, fileType, filename) => {
  return axiosInstance.post(`${BASE_URL}/documents/upload_request`, { 
    userId: payload.ownerId.value,
    directoryId: payload.directoryId.value || '',
    fileType,
    filename
  }
  );
};

export const uploadChunk = async (uploadRequestId, chunk, chunkNumber) => {
  let formData = new FormData();
  formData.append('chunkNumber', chunkNumber);
  formData.append('chunk', chunk);
  formData.append('uploadRequestId', uploadRequestId);

  return axios.post(`${BASE_URL}/documents/chunk_upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': getAuthToken()
    }
  });
};

export const completeUpload = async (uploadRequestId) => {
  return axiosInstance.post(`${BASE_URL}/documents/complete_upload`, { uploadRequestId });
};

export const createDocument = async (payload, file, setFilesToUpload, filesToUpload) => {
  let formData = new FormData();
  formData.append('userId', payload.ownerId.value);
  formData.append('directoryId', payload.directoryId.value || '');
  formData.append('docFile', file);

  return axios.post(`${BASE_URL}/documents`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': getAuthToken()
    },
    onUploadProgress: (e) => {
      setFilesToUpload(
        filesToUpload.map(f => {
          if(f.order !== file.order) return f;
  
          f.uploadPercent = Math.round((e.loaded * 100) / e.total) || 0;
          return f;
        })
      );
    }
  })
    .then(() => {
      setFilesToUpload(
        filesToUpload.map(f => {
          if(f.order !== file.order) return f;
  
          f.status = 'success';
          return f;
        })
      );
    })
    .catch(() => {
      setFilesToUpload(
        filesToUpload.map(f => {
          if(f.order !== file.order) return f;
  
          f.status = 'error';
          return f;
        })
      );
    });
};

export const rejectDocuments = async (ids) => {
  return axiosInstance.post(`${BASE_URL}/documents/reject`, { ids });
};

export const approveDocuments = async (ids) => {
  return axiosInstance.post(`${BASE_URL}/documents/approve`, { ids });
};

export const deleteDocuments = async (ids) => {
  if (ids && ids.length === 1) {
    return axiosInstance.delete(`${BASE_URL}/documents/${ids[0]}`);
  }

  return axiosInstance.post(`${BASE_URL}/documents/destroy_all`, { ids });
};

export const deleteDirectories = async (ids) => {
  if (ids && ids.length === 1) {
    return axiosInstance.delete(`${BASE_URL}/directories/${ids[0]}`);
  }

  return axiosInstance.post(`${BASE_URL}/directories/destroy_all`, { ids });
};

export const getDocumentsToApprove = async () => {
  return axiosInstance.get(`${BASE_URL}/documents/waiting_approval${window.location.search}`);
};

export const getDirectoriesAndDocuments = async () => {
  return axiosInstance.get(`${BASE_URL}/directories/dir_docs${window.location.search}`);
};

export const getDocuments = async () => {
  return axiosInstance.get(`${BASE_URL}/documents${window.location.search}`);
};

export const createUser = async (payload) => {
  return axiosInstance.post(`${BASE_URL}/users`, { user: payload });
};

export const updateUser = async (id, payload) => {
  return axiosInstance.put(`${BASE_URL}/users/${id}`, { user: payload });
};

export const getUsers = async () => {
  return axiosInstance.get(`${BASE_URL}/users${window.location.search}`);
};

export const getUser = async (id) => {
  return axiosInstance.get(`${BASE_URL}/users/${id}`);
};

export const deleteUsers = async (ids) => {
  if (ids && ids.length === 1) {
    return axiosInstance.delete(`${BASE_URL}/users/${ids[0]}`);
  }

  return axiosInstance.post(`${BASE_URL}/users/destroy_all`, { ids });
};
